import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);
const savedNews = localStorage.getItem("news");
const savedJoin = localStorage.getItem("join");
export default new Vuex.Store({
  state: {
    count: 0,
    news: savedNews ? JSON.parse(savedNews) : {},
    joinlist: savedJoin ? JSON.parse(savedJoin) : [],
  },
  mutations: {
    increment(state) {
      state.count++;
    },
    TOGGLE_DEVICE: (state, info) => {
      state.news = info;
      localStorage.setItem("news", JSON.stringify(info));
    },
    TOGGLE_join: (state, list) => {
      state.joinlist = list;
      localStorage.setItem("join", JSON.stringify(list));
    },
  },
  actions: {
    increment({ commit }) {
      commit("increment");
    },
    setnews({ commit }, info) {
      commit("TOGGLE_DEVICE", info);
    },
    setjoinlist({ commit }, list) {
      commit("TOGGLE_join", list);
    },
  },
  modules: {},
});
